// extracted by mini-css-extract-plugin
var _1 = "fFjiJRsNuHxAQS1eSEr7";
export { _1 as "column" }
